/**
 * Component to format an account number with spaces
 * @param accountNumber
 * @returns formatted amount.
 */
export const FormatAccountNumber = (accountNumber?: string) => {
  if (!accountNumber) return "";
  const trimmedAccountNumber = accountNumber.replace(/\s/g, "").trim();
  if (trimmedAccountNumber.length !== 11) return "";

  let formattedAccountNumber = "";

  [...Array(trimmedAccountNumber.length)].forEach((_, i) => {
    if (i === 4 || i === 6) formattedAccountNumber += " ";
    formattedAccountNumber += trimmedAccountNumber[i];
  });

  return formattedAccountNumber;
};
